import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { deliveryAPI } from '../../services/api';

function CODSettlementVerification() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyPayment();
  }, []);

  const verifyPayment = async () => {
    const orderId = searchParams.get('order_id');

    if (!orderId) {
      setStatus('error');
      setMessage('Invalid payment verification link');
      setVerifying(false);
      return;
    }

    try {
      console.log('🔍 Verifying COD settlement payment for order:', orderId);

      const response = await deliveryAPI.verifyCodSettlementPayment(orderId);

      if (response.data.success) {
        setStatus('success');
        setMessage(response.data.message || 'COD settlement payment successful!');
      } else {
        setStatus('error');
        setMessage(response.data.message || 'Payment verification failed');
      }
    } catch (error) {
      console.error('❌ Verification error:', error);
      setStatus('error');
      setMessage(error.response?.data?.message || 'Payment verification failed. Please contact support.');
    } finally {
      setVerifying(false);
    }
  };

  const handleContinue = () => {
    navigate('/delivery/my-deliveries');
  };

  if (verifying) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eef3 100%)'
      }}>
        <div className="card" style={{ textAlign: 'center', padding: 'var(--space-2xl)', maxWidth: '500px' }}>
          <div style={{ fontSize: '80px', marginBottom: 'var(--space-lg)' }}>🔄</div>
          <h2 style={{
            fontSize: 'var(--font-size-2xl)',
            fontWeight: '700',
            color: 'var(--gray-900)',
            marginBottom: 'var(--space-md)'
          }}>
            Verifying Payment
          </h2>
          <p style={{ color: 'var(--gray-600)', fontSize: 'var(--font-size-lg)' }}>
            Please wait while we verify your COD settlement payment...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eef3 100%)'
    }}>
      <div className="card fade-in" style={{ textAlign: 'center', padding: 'var(--space-2xl)', maxWidth: '500px' }}>
        {status === 'success' ? (
          <>
            <div style={{ fontSize: '100px', marginBottom: 'var(--space-lg)' }}>✅</div>
            <h2 style={{
              fontSize: 'var(--font-size-3xl)',
              fontWeight: '700',
              color: 'var(--success)',
              marginBottom: 'var(--space-md)'
            }}>
              Payment Successful!
            </h2>
            <p style={{ color: 'var(--gray-600)', fontSize: 'var(--font-size-lg)', marginBottom: 'var(--space-xl)' }}>
              {message}
            </p>
            <p style={{ color: 'var(--gray-500)', fontSize: 'var(--font-size-base)', marginBottom: 'var(--space-xl)' }}>
              Your COD amount has been successfully transferred to the platform. The order has been marked as settled.
            </p>
            <button
              onClick={handleContinue}
              className="btn btn-primary"
              style={{ width: '100%', padding: 'var(--space-md)' }}
            >
              Back to My Deliveries
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: '100px', marginBottom: 'var(--space-lg)' }}>❌</div>
            <h2 style={{
              fontSize: 'var(--font-size-3xl)',
              fontWeight: '700',
              color: 'var(--danger)',
              marginBottom: 'var(--space-md)'
            }}>
              Payment Failed
            </h2>
            <p style={{ color: 'var(--gray-600)', fontSize: 'var(--font-size-lg)', marginBottom: 'var(--space-xl)' }}>
              {message}
            </p>
            <p style={{ color: 'var(--gray-500)', fontSize: 'var(--font-size-base)', marginBottom: 'var(--space-xl)' }}>
              Please try again or contact support if the problem persists.
            </p>
            <button
              onClick={handleContinue}
              className="btn btn-primary"
              style={{ width: '100%', padding: 'var(--space-md)' }}
            >
              Back to My Deliveries
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default CODSettlementVerification;
